// Mock data for C++ Programming Course in Amman

export const cppMockData = {
  // Site Information
  siteInfo: {
    name: "Qubit Center",
    tagline: "Master C++ Programming",
    description: "Learn C++ programming step-by-step in Amman. From basics to advanced problem solving - building your skills like LEGO blocks."
  },
  
  // Hero Section
  hero: {
    announcement: "📍 IN-PERSON CLASSES IN AMMAN",
    title: "Master C++ Programming Step by Step",
    subtitle: "Learn C++ from scratch in our Amman classroom. Our unique LEGO-style approach builds your programming skills block by block with hands-on problem solving.",
    primaryCTA: "Enroll Now",
    secondaryCTA: "View Schedule",
    location: "Amman, Jordan"
  },
  
  // Course Stats
  stats: [
    { number: "28+", label: "Lessons" },
    { number: "100+", label: "Problems Solved" },
    { number: "12", label: "Weeks Duration" },
    { number: "20", label: "Students Per Class" }
  ],
  
  // Curriculum - Based on the image provided
  curriculum: [
    {
      week: 1,
      title: "Getting Started & Basics",
      color: "cpp-accent-blue",
      lessons: [
        "Lesson 1: Basics 1 - Install IDE",
        "Lesson 2: CPP syntax",
        "Lesson 3: Output (print) + \\n + std",
        "Lesson 4: Comments",
        "Lesson 5: \\n or endl",
        "Lesson 6: Escape sequences"
      ]
    },
    {
      week: 2,
      title: "Variables & Input/Output",
      color: "cpp-accent-green",
      lessons: [
        "Lesson 7: Variables",
        "Lesson 8: User input",
        "Lesson 9: Arithmetic operators",
        "Lesson 10: Operators ++,--",
        "Lesson 11: x++VS++x,x--VS--x",
        "Lesson 12: Assignment operators"
      ]
    },
    {
      week: 3,
      title: "Operators & Logic",
      color: "cpp-accent-purple",
      lessons: [
        "Lesson 13: Relational operators", 
        "Lesson 14: Logical operators AND OR NOT",
        "Lesson 15: Math function",
        "Lesson 16: Structures",
        "Lesson 17: Enums",
        "Lesson 18: Enums and structures"
      ]
    },
    {
      week: 4,
      title: "Data Types & Strings",
      color: "cpp-accent-orange",
      lessons: [
        "Lesson 19: Data type conversion",
        "Lesson 20: Strings", 
        "Lesson 21: Functions part 1",
        "Lesson 22: Functions part 2",
        "Lesson 23: Structures with function",
        "Lesson 24: Arrays"
      ]
    },
    {
      week: 5,
      title: "Arrays & Conditional Statements",
      color: "cpp-accent-blue",
      lessons: [
        "Lesson 25: Arrays and function",
        "Lesson 26: Array of structure", 
        "Lesson 27: If, if else",
        "Lesson 28: Enums with if",
        "Lesson 29: Switch",
        "Lesson 30: Function in function"
      ]
    },
    {
      week: 6,
      title: "Loops & Advanced Concepts",
      color: "cpp-accent-green",
      lessons: [
        "Lesson 31: For loop",
        "Lesson 32: For loop with arrays",
        "Lesson 33: For loop in for loop", 
        "Lesson 34: While loop",
        "Lesson 35: Do while loop",
        "Lesson 36: Break & Continue statements"
      ]
    }
  ],
  
  // Features
  features: [
    {
      title: "Step-by-Step Learning",
      description: "Like building with LEGO blocks - each concept builds on the previous one",
      icon: "building-blocks",
      color: "cpp-accent-blue"
    },
    {
      title: "Problem Solving Focus",
      description: "50+ practical coding problems to strengthen your programming skills",
      icon: "code",
      color: "cpp-accent-green"
    },
    {
      title: "In-Person Classes",
      description: "Face-to-face learning in Amman with direct instructor support",
      icon: "users",
      color: "cpp-accent-purple"
    },
    {
      title: "Beginner Friendly",
      description: "No prior programming experience required - start from absolute zero",
      icon: "star",
      color: "cpp-accent-orange"
    }
  ],
  
  // Testimonials
  testimonials: [
    {
      name: "Ahmed Al-Rashid",
      role: "Engineering Student",
      text: "The step-by-step approach made C++ so easy to understand. I went from zero to building real programs!",
      avatar: "AR",
      rating: 5
    },
    {
      name: "Layla Mahmoud", 
      role: "Computer Science Graduate",
      text: "Best programming course in Amman! The instructor explains complex concepts in simple ways.",
      avatar: "LM",
      rating: 5
    },
    {
      name: "Omar Khalil",
      role: "Software Developer",
      text: "The problem-solving approach really helped me think like a programmer. Highly recommended!",
      avatar: "OK",
      rating: 5
    }
  ],
  
  // Course Information
  courseInfo: {
    price: "400 JOD (160 JOD per month)",
    duration: "10 Weeks",
    schedule: "Sat & Wed 6-8 PM",
    location: "Queen Rania St 29-17, Amman",
    classSize: "Max 10 Students",
    certificate: "Course Completion Certificate"
  },
  
  // Contact Information
  contact: {
    phone: "+962 77 192 5032",
    email: "",
    address: "Queen Rania St 29-17, Amman",
    whatsapp: "+962 77 192 5032"
  },
  
  // Schedule
  schedule: [
    {
      batch: "class timing",
      days: "Sunday - Tuesday - Thursday", 
      time: "5:00 - 7:30 PM",
      startDate: "Wednesday 17/9/2025",
      status: "Available"
    },
    {
      batch: "",
      days: "",
      time: "", 
      startDate: "",
      status: ""
    }
  ]
};